import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { i18nInit } from '../i18n';
import { SupportModal as SupportModalBase } from '../components/modals/support-modal/support-modal';
export class SupportModal extends React.Component {
    render() {
        const baseUrl = this.props.baseUrl;
        const origin = this.props.origin;
        const msId = this.props.msId;
        const authorizationHeader = this.props.authorizationHeader;
        const handleClose = this.props.closeModal;
        return (React.createElement("div", null,
            React.createElement(I18nextProvider, { i18n: i18nInit({ locale: this.props.locale }) },
                React.createElement(SupportModalBase, { app: this.props.app, msId: msId, origin: origin, closeModal: handleClose, authorizationHeader: authorizationHeader, baseUrl: baseUrl, clickSource: this.props.clickSource, pageName: this.props.pageName, showUserActionNotification: this.props.showUserActionNotification }))));
    }
}
//# sourceMappingURL=support-modal.js.map